import { render, staticRenderFns } from "./StudentsModal.vue?vue&type=template&id=2785691b&scoped=true&"
import script from "./StudentsModal.vue?vue&type=script&lang=js&"
export * from "./StudentsModal.vue?vue&type=script&lang=js&"
import style0 from "./StudentsModal.vue?vue&type=style&index=0&id=2785691b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2785691b",
  null
  
)

export default component.exports